module.exports = __webpack_public_path__ + "static/media/29ADMSPC1.b18f78a1.jpg";